import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import {
  CREATE_COLOR_MOCK,
  DELETE_COLOR_MOCK,
  GET_COLORS_MOCK,
  UPDATE_COLOR_MOCK,
} from '@shared/mocks/colors.mock';

import {
  CreateMaterialColorDto,
  MaterialColor,
  UpdateMaterialColorDto,
} from './interfaces/colors.interfaces';

import { HttpInterceptor } from '@interceptors/http/http.interceptor';

@Injectable({
  providedIn: 'root',
})
export class ColorsService {
  private http = inject(HttpInterceptor);
  private readonly apiUrl = 'material-colors';

  public getColors(): Observable<MaterialColor[]> {
    return this.http.get(this.apiUrl, GET_COLORS_MOCK);
  }

  public getColorsAdmin(): Observable<MaterialColor[]> {
    return this.http.get(`${this.apiUrl}/admin`, GET_COLORS_MOCK);
  }

  public createColor(dto: CreateMaterialColorDto): Observable<MaterialColor> {
    return this.http.post(this.apiUrl, dto, CREATE_COLOR_MOCK);
  }

  public updateColor(id: string, dto: UpdateMaterialColorDto, skipValidation = false): Observable<MaterialColor> {
    const body = skipValidation ? { ...dto, skipValidation: true } : dto;
    return this.http.patch(`${this.apiUrl}/${id}`, body, UPDATE_COLOR_MOCK);
  }

  public deleteColor(id: string): Observable<void> {
    return this.http.delete(`${this.apiUrl}/${id}`, DELETE_COLOR_MOCK);
  }
}
